export default class rol {
    constructor($scope,
                $routeParams,
                method,
                rolesService,
                $location,
                $uibModal,
                toastr) {
        this.scope = $scope;
        this.location = $location;
        this.toastr = toastr;
        this.modal = $uibModal;
        switch (method) {
            case 'list':
                this.list(rolesService);
                break;
            case 'new':
                this.create(rolesService);
                break;
            case 'view':
                this.view($routeParams,
                    rolesService);
                break;
        }
    }

    list(rolesService) {

        let self = this.scope;
        rolesService.getAll().then((resp, err) => {
            self.roles = resp.data.message;
        });

        self.getItemPage = (item) => {
            let index = self.roles.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, rolesService);

        /*
        this.scope.inAction = false;
        this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                rolesService.delete({_id: id}).then((resp) => {
                    if (resp.data.success == true) {
                        this.toastr.success('Rol eliminado correctamente!', 'Success!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                        window.location.reload();
                    }
                })
                .catch((err) => {
                    this.toastr.error('Error', 'Error al eliminar el rol!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };*/
    }

    create(rolesService) {
        this.scope.rol = {};

        /** Contamos los permisos seleccionados para habilitar el boton de guardado**/
        this.scope.enabledSave = false;
        this.scope.rol = {
            permisos : {
                in : {r:0, w:0},
                ot : {r:0, w:0},
                eq : {r:0, w:0}
            }
        };
        let countPermisos = () => {
            let lenPermisos = 0;
            if (angular.isDefined(this.scope.rol.permisos.in) && true === this.scope.rol.permisos.in.r  ){ lenPermisos++;}
            if (angular.isDefined(this.scope.rol.permisos.in) && true === this.scope.rol.permisos.in.w ) { lenPermisos++;}
            if (angular.isDefined(this.scope.rol.permisos.ot) && true === this.scope.rol.permisos.ot.r ) { lenPermisos++;}
            if (angular.isDefined(this.scope.rol.permisos.ot) && true === this.scope.rol.permisos.ot.w ) { lenPermisos++;}
            if (angular.isDefined(this.scope.rol.permisos.eq) && true === this.scope.rol.permisos.eq.r ) { lenPermisos++;}
            if (angular.isDefined(this.scope.rol.permisos.eq) && true === this.scope.rol.permisos.eq.w ) { lenPermisos++;}
			if (angular.isDefined(this.scope.rol.permisos.pi) && true === this.scope.rol.permisos.pi.r ) { lenPermisos++;}
            if (angular.isDefined(this.scope.rol.permisos.pi) && true === this.scope.rol.permisos.pi.w ) { lenPermisos++;}
            return lenPermisos;
        };

        this.scope.$watch(countPermisos, (nuevo) => {
            if (nuevo > 0) {
                this.scope.enabledSave = true;
            } else {
                this.scope.enabledSave = false;
            }
        });

        this.scope.inAction = false;
        this.scope.guardar = () => {
            if (!this.scope.inAction && this.scope.enabledSave) {
                this.scope.inAction = true;
                rolesService.save(this.scope.rol).then((resp) => {
                    this.toastr.success('Rol creado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/rol');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al crear el rol!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };
    }

    view($routeParams,
         rolesService) {

        rolesService.getById({_id: $routeParams.id}).then((resp) => {

            this.scope.rol = resp.data.message;
        }).catch((er) => {
            console.log(er);
        });

        /** Contamos los permisos seleccionados para habilitar el boton de guardado**/
        this.scope.enabledSave = false;
        let countPermisos = () => {
            let lenPermisos = 0;

            if (angular.isUndefined(this.scope.rol)) { return 0;}
            if (angular.isUndefined(this.scope.rol.permisos)) { return 0;}
            if (angular.isDefined(this.scope.rol.permisos.in) && this.scope.rol.permisos.in.w ){ lenPermisos++;}
            if (angular.isDefined(this.scope.rol.permisos.in) && this.scope.rol.permisos.in.r ) { lenPermisos++;}
            if (angular.isDefined(this.scope.rol.permisos.ot) && this.scope.rol.permisos.ot.w ) { lenPermisos++;}
            if (angular.isDefined(this.scope.rol.permisos.ot) && this.scope.rol.permisos.ot.r ) { lenPermisos++;}
            if (angular.isDefined(this.scope.rol.permisos.eq) && this.scope.rol.permisos.eq.w ) { lenPermisos++;}
            if (angular.isDefined(this.scope.rol.permisos.eq) && this.scope.rol.permisos.eq.r ) { lenPermisos++;}
            if (angular.isDefined(this.scope.rol.permisos.pi) && this.scope.rol.permisos.pi.w ) { lenPermisos++;}
            if (angular.isDefined(this.scope.rol.permisos.pi) && this.scope.rol.permisos.pi.r ) { lenPermisos++;}
            return lenPermisos;
        };

        this.scope.$watch(countPermisos, (nuevo) => {
            if (nuevo > 0) {
                this.scope.enabledSave = true;
            } else {
                this.scope.enabledSave = false;
            }
        });


        this.scope.inAction = false;
        this.scope.guardar = () => {

            if (!this.scope.inAction && this.scope.enabledSave && this.scope.rol.index !== null) {
                this.scope.inAction = true;
                rolesService.update(this.scope.rol).then((resp) => {
                    this.toastr.success('Rol modificado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/rol');
                })
                .catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al modificar el rol!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        };
    }

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Rol</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar el rol: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.roles.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Rol eliminado correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar el Rol!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}



// WEBPACK FOOTER //
// ./app/js/controllers/rol/rol.js